<template>
  <div id="home-page">
    <section class="banner-section" data-aos="fade">
      <div class="placed-backg banner-section-inner">
        <div class="container">
          <div class="row">
            <div class="col-12 col-info">
              <h1 class="title" data-aos="fade-down">Todo lo legal<br />en <i>tiempo real</i></h1>

              <div class="d-block mt-4" data-aos="fade-down">
                <router-link to="/directorio" class="mb-2 mb-sm-0 mr-sm-2 btn-s1 btn-outline-color-1">Busco Solución Legal <i class="fa-regular fa-circle-arrow-right icon-1"></i></router-link>
                <router-link to="/afiliacion" class="ml-sm-2 btn-s1 bg-cprimary">Soy Abogado <i class="fa-regular fa-circle-arrow-right icon-1"></i></router-link>
              </div>

              <div class="d-block mt-4 pt-1 pt-sm-3 box-text" data-aos="fade-up">
                <div class="b-text">
                  <p>
                    UNLAWK nace para transformar la confusión en certidumbre. Conectamos a quienes necesitan resolver con quienes pueden hacerlo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-us-section">
      <div class="box-why" data-aos="fade">
        <div class="container">
          <div class="row">
            <div class="col-12 col-text">
              <div class="b-title">
                <h6 class="title" data-aos="fade-up">Por qué existimos</h6>
              </div>

              <h2 class="subtitle" data-aos="fade" data-aos-delay="200">
                El sistema legal no necesita<br />
                reinventarse, necesita conectarse.
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div class="box-mission">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-text">
              <h6 class="title" data-aos="fade">Nuestra Misión</h6>

              <p data-aos="fade" data-aos-delay="100">
                Durante los años los procesos legales han permanecido bloqueados detrás de un lenguaje técnico, procesos frívolos y relaciones impersonales. La marca no aspira a cambiar las leyes, sino a acercarlas.
              </p>

              <br />
              <p class="f-w-700" data-aos="fade" data-aos-delay="200">
                Conectamos personas, negocios y oportunidades. Formamos una comunidad donde la colaboración genera movimiento.
              </p>

              <br />
              <p data-aos="fade" data-aos-delay="200">
                <router-link class="btn-s1 bg-cprimary" to="/como-funciona">¿Cómo funciona?</router-link>
              </p>
            </div>

            <div class="col-lg-6 col-image"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="manifest-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-text">
            <h6 class="title" data-aos="fade">Manifiesto</h6>

            <h2 class="manifest-title" data-aos="fade" data-aos-delay="200">
              Creemos en un<br />
              mundo legal<br />
              más accesible,<br />
              <span>más humano.</span>
            </h2>

            <img class="isotipo" data-aos="fade" data-aos-delay="400" src="public/images/isotipo.png" />
          </div>

          <div class="col-lg-7 col-list mt-3 mt-lg-0">
            <p class="l-1" data-aos="fade-left">
              Estamos aquí para acercar, traducir y conectar.
            </p>
            <p class="l-2" data-aos="fade-left" data-aos-delay="150">
              La justicia debe ser accesible para todos.
            </p>
            <p class="l-3" data-aos="fade-left" data-aos-delay="300">
              Porque cuando lo legal se entiende, todo se desbloquea.
            </p>
            <p class="l-4" data-aos="fade-left" data-aos-delay="450">
              La ley existe para acompañarte, no para detenerte.
            </p>
            <p class="l-5" data-aos="fade-left" data-aos-delay="600">
              Para hacer que los procesos avancen y las personas comprendan.
            </p>
            <p class="l-6" data-aos="fade-left" data-aos-delay="750">
              Creemos en un espacio donde abogados y clientes hablen el mismo idioma.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="concept-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-info">
            <h6 class="title-s0" data-aos="fade">Concepto</h6>

            <h2 class="title-s1" data-aos="fade">Haz el clic.</h2>
            
            <br />
            <p data-aos="fade">
              En un ecosistema legal lleno de obstáculos, hay un momento que lo cambia todo: <strong class="f-w-700">el instante en que la confusión se convierte en claridad.</strong> Ese es nuestro propósito.
            </p>
          </div>

          <div class="col-12 col-steps">
            <div class="row">
              <div class="col-lg-4 col-step" data-aos="fade-up">
                <div class="box">
                  <h4 class="title"><span>Confusión</span></h4>

                  <h3 class="subtitle">El problema legal parece inaccesible.</h3>

                  <p class="description">
                    Demasiado ruido, muy poco orden.
                  </p>

                  <div class="row row-bottom">
                    <div class="col col-mini-text">
                      <h6>Fase 1</h6>
                    </div>

                    <div class="col col-image" data-aos="fade-up" data-aos-offset="-150">
                      <img src="public/images/pages/home/step-1.png" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-step" data-aos="fade-up" data-aos-delay="250">
                <div class="box">
                  <h4 class="title"><span>El clic</span></h4>

                  <h3 class="subtitle">La IA analiza, perfila y conecta.</h3>

                  <p class="description">
                    El panorama se aclara de golpe.
                  </p>

                  <div class="row row-bottom">
                    <div class="col col-mini-text">
                      <h6>Fase 2</h6>
                    </div>

                    <div class="col col-image" data-aos="fade-up" data-aos-delay="100" data-aos-offset="-150">
                      <img src="public/images/pages/home/step-2.png" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 col-step" data-aos="fade-up" data-aos-delay="500">
                <div class="box">
                  <h4 class="title"><span>Claridad</span></h4>

                  <h3 class="subtitle">Tienes al abogado correcto.</h3>

                  <p class="description">
                    Y el camino por delante.
                  </p>

                  <div class="row row-bottom">
                    <div class="col col-mini-text">
                      <h6>Fase 3</h6>
                    </div>

                    <div class="col col-image" data-aos="fade-up" data-aos-delay="200" data-aos-offset="-150">
                      <img src="public/images/pages/home/step-3.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>       

        <hr class="line" />
      </div>
    </section>

    <section class="why-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-info">
            <h6 class="title-s0" data-aos="fade-right">Cómo funciona</h6>

            <h2 class="title-s1" data-aos="fade-right" data-aos-delay="150">Tres pasos. Un resultado.</h2>
          </div>

          <div class="col-12 col-steps">
            <div class="row">
              <div class="col-lg-4 col-step c-1">
                <div class="box">
                  <div class="placed-backg box-image img-1" data-aos="fade-up">
                    <img src="public/images/pages/home/step-2-0.png" />
                  </div>

                  <div class="box-text" data-aos="fade-up" data-aos-delay="100" data-aos-offset="250">
                    <h4 class="title">Describe tu caso</h4>

                    <p>
                      <strong>Cuéntanos en lenguaje natural.</strong><br />
                      Sin tecnicismos, sin formularios.
                    </p>
                  </div>
                </div>

                <hr class="line" />
              </div>

              <div class="col-lg-4 col-step c-2">
                <div class="box">
                  <div class="placed-backg box-image img-2" data-aos="fade-up" data-aos-delay="150" data-aos-offset="150">
                    <img src="public/images/pages/home/step-2-0.png" />
                  </div>

                  <div class="box-text" data-aos="fade-up" data-aos-delay="300" data-aos-offset="150">
                    <h4 class="title">La IA perfila y hace match</h4>

                    <p>
                      El algoritmo analiza, comprende a detalle el problema y <strong>sugiere al abogado especialista</strong> más adecuado para ti.
                    </p>
                  </div>
                </div>

                <hr class="line" />
              </div>

              <div class="col-lg-4 col-step c-3">
                <div class="box" data-aos="fade-up" data-aos-delay="400" data-aos-offset="150">
                  <div class="placed-backg box-image img-3">
                    <img src="public/images/pages/home/step-2-0.png" />
                  </div>

                  <div class="box-text" data-aos="fade-up" data-aos-delay="550" data-aos-offset="150">
                    <h4 class="title">Conexión directa</h4>

                    <p>
                      Te conectamos con contexto completo.<br />
                      <strong>Tú en control, legalmente.</strong>
                    </p>
                  </div>
                </div>

                <hr class="line" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="services-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-text pr-lg-5">
            <h6 class="title-s0" data-aos="fade-up">Servicios</h6>

            <h2 class="title-s1" data-aos="fade-up" data-aos-delay="150" data-aos-offset="50">Servicios Cubiertos.</h2>

            <div class="b-image" data-aos="fade-up" data-aos-delay="200" data-aos-offset="150">
              <img src="public/images/pages/home/img-services.png" />
            </div>

            <div class="b-text" data-aos="fade-up" data-aos-delay="350" data-aos-offset="200">
              <p>
                <router-link class="btn-s1 mb-2 mb-sm-0 mr-sm-2 btn-outline-color-2" to="/directorio">Busco Solución Legal <i class="fa-regular fa-circle-arrow-right icon-1"></i></router-link>
                <router-link class="btn-s1 ml-sm-2 bg-cprimary" to="/afiliacion">Soy Abogado <i class="fa-regular fa-circle-arrow-right icon-1"></i></router-link>
              </p>  
            </div>
          </div>

          <div class="col-lg-6 col-list">
            <p data-aos="fade-left">
              Contratos
            </p>
            <p data-aos="fade-left" data-aos-delay="100" data-aos-offset="50">
              Arrendamientos
            </p>
            <p data-aos="fade-left" data-aos-delay="200" data-aos-offset="100">
              Laboral
            </p>
            <p data-aos="fade-left" data-aos-delay="300" data-aos-offset="120">
              Civil
            </p>
            <p data-aos="fade-left" data-aos-delay="400" data-aos-offset="120">
              Mercantil
            </p>
            <p data-aos="fade-left" data-aos-delay="500" data-aos-offset="120">
              NDAs
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="testimonials-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-image" data-aos="fade" data-aos-delay="200" data-aos-offset="200">
            <div class="img placed-backg" :style="{ backgroundImage: 'url(public/images/pages/home/img-testimonials.jpg' }"></div>
            <!-- <img class="placed-backg" src="public/images/pages/home/bg-testimonials.png"  /> -->
          </div>

          <div class="col-12 col-info">
            <h6 class="title-s0" data-aos="fade-right">Testimonios</h6>
            <h2 class="title-s1" data-aos="fade-right" data-aos-delay="150">Lo que dicen nuestros usuarios.</h2>

            <div class="box-carousel">
              <div class="btns-testimonials-carousel" data-aos="fade-left" data-aos-delay="150">
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </div>

              <swiper class="swiper" :options="testimonialsOptions" data-aos="fade-left" data-aos-delay="300">
                <swiper-slide v-for="(t, tInx) in 4" :key="'tInx-'+tInx">
                  <div class="row box">
                    <div class="col col-image">
                      <div class="img-user"></div>
                    </div>

                    <div class="col col-text">
                      <h6 class="name">Usuario {{ tInx + 1 }}</h6>
                      <h6 class="verified">Cliente Verificado</h6>
                    </div>

                    <div class="col-12 col-content">
                      <p>
                        "Encontré al abogado en minutos".
                      </p>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>

export default {
  data() {
    return {
      // == Carousel options ==
      testimonialsOptions: {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1200: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 20
          },
        },
      },
      // == ==
    }
  },

  methods: {
  }
}
</script>